import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface UpdatePedidoData {
  pedidoId: string;
  updates: {
    observacoes?: string | null;
  };
}

export function useUpdatePedido() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ pedidoId, updates }: UpdatePedidoData) => {
      const { data, error } = await supabase
        .from('pedidos')
        .update(updates)
        .eq('id', pedidoId)
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: (data, variables) => {
      // ✅ Invalidar apenas queries relacionadas ao pedido específico
      queryClient.invalidateQueries({ queryKey: ['pedido', variables.pedidoId] });
      queryClient.invalidateQueries({ queryKey: ['pedido-detail', variables.pedidoId] });
      queryClient.invalidateQueries({ queryKey: ['pedido-itens-completo', variables.pedidoId] });
      queryClient.invalidateQueries({ queryKey: ['kanban'], exact: false });
      queryClient.invalidateQueries({ queryKey: ['planilha-itens'], exact: false });
      
      toast.success('Pedido atualizado com sucesso');
    },
    onError: (error: Error) => {
      console.error('Erro ao atualizar pedido:', error);
      toast.error(`Erro ao atualizar pedido: ${error.message}`);
    },
  });
}
